import { render } from "./taskIndex.vue?vue&type=template&id=4e527c22"
import script from "./taskIndex.vue?vue&type=script&lang=js"
export * from "./taskIndex.vue?vue&type=script&lang=js"

import "./taskIndex.vue?vue&type=style&index=0&id=4e527c22&lang=scss"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__